import { MessageBar, MessageBarBody, MessageBarTitle, Link, makeStyles } from '@fluentui/react-components';
import { useSubscriptionInfo } from '../stores/authStore.js';

const useStyles = makeStyles({
  wrap: {
    padding: '0 var(--space-xxl) 4px',
  },
});

/**
 * Banner sticky que indica modo lectura cuando la suscripción OPUS 27
 * está vencida. m0 deja consultar proyectos viejos pero bloquea todas
 * las mutaciones (POST/PATCH/DELETE) con 403 OPUS_SUBSCRIPTION_INACTIVE.
 *
 * Se monta en `ProtectedRoute` para que aparezca en todas las páginas
 * autenticadas. NO se cierra: si la sub está vencida, la condición
 * persiste hasta renovación o logout.
 */
export function SubscriptionExpiredBanner() {
  const styles = useStyles();
  const { expired, expiresAt } = useSubscriptionInfo();
  if (!expired) return null;

  const dateLabel = expiresAt
    ? new Date(expiresAt).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' })
    : null;

  return (
    <div className={styles.wrap}>
      <MessageBar intent="error" layout="multiline">
        <MessageBarBody>
          <MessageBarTitle>Modo solo lectura — Suscripción OPUS 27 vencida</MessageBarTitle>
          {dateLabel ? <>Tu suscripción venció el <strong>{dateLabel}</strong>. </> : null}
          Puedes ver tus proyectos pero no crear ni modificar nada hasta renovarla.{' '}
          <Link href="https://www.ecosoft.com.mx/opus" target="_blank" rel="noreferrer">
            Renovar OPUS 27
          </Link>
        </MessageBarBody>
      </MessageBar>
    </div>
  );
}
